<pfx-panel
  title="Pflegeberatung §37.3 SGB XI"
  [toggleable]="true"
  [scrollableContent]="true"
>
  @if (isLoading()) {
    <pfx-skeleton-loading></pfx-skeleton-loading>
    <pfx-skeleton-loading></pfx-skeleton-loading>
    <pfx-skeleton-loading></pfx-skeleton-loading>
  } @else {
    <div class="flex flex-col gap-2">
      <div class="flex gap-6">
        <div class="flex flex-col flex-1 gap-2">
          <h6 class="mb-1">Nächste Beratung</h6>
          <p>
            Termin geplant:
            @if (nextConsultation()) {
              {{ nextConsultation() | date: 'dd.MM.yyyy' }}
            } @else {
              <span class="text-orange-500">
                - (fällig bis {{ lastConsultationExpiryDate() | date: 'dd.MM.yyyy' }})
              </span>
            }
            <br />
            Letzter Termin:
            @if (lastConsultation()) {
              {{ lastConsultation() | date: 'dd.MM.yyyy' }}
            } @else {
              -
            }
            <br />
            Pflegegrad: {{ careLevel() }}
          </p>
        </div>
        <div class="flex flex-col flex-1 gap-2">
          <h6 class="mb-1">Letze Beratungen</h6>
          <ul class="p-0 m-0 list-none border-0">
            @for (consultation of consultationDocumentations(); track consultation._id) {
              <li class="flex items-center">
                <div class="flex items-center">
                  <div class="ml-2">
                    <div>
                      <a
                        [routerLink]="['/business-partner-center', consultation.partners.caregiver._id]"
                        class="p-0 font-bold p-button-link"
                        >{{ consultation.partners.caregiver.mainAddress.firstname }}
                        {{ consultation.partners.caregiver.mainAddress.lastname }}</a
                      >
                    </div>
                    <small class="text-muted-color">
                      <pfx-icon-with-text
                        class="no-spacing"
                        [icon]="icons.signature"
                        >{{ consultation.period.startAt | date: 'dd.MM.yyyy' }}</pfx-icon-with-text
                      >
                    </small>
                  </div>
                </div>
              </li>
            } @empty {
              <li class="flex items-center">Keine Beratungen gefunden</li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
</pfx-panel>
